const envBaseUrl = ((environment) => {
  switch (environment) {
    case 'development':
      return 'http://localhost:3001/api';
    case 'staging':
      return 'https://still-lowlands-61733.herokuapp.com/api';
    default:
      return 'https://www.rtamedsafety.com/api';
  }
})(process.env.REACT_APP_ENV);



module.exports = { apiBaseURL: envBaseUrl };



// WEBPACK FOOTER //
// ./src/config/settings.js